export default "__VITE_ASSET__MJXKAIWB__"